import { useMemo } from 'react';

export function useRegulatoryAlerts(state, session) {
  const userId = session?.userId;
  const isAdmin = session?.role === 'admin' || session?.role === 'super-admin';

  return useMemo(() => {
    const alerts = state?.activeRegulatoryAlerts || [];
    const urgentAlerts = alerts.filter((alert) => {
      if (!alert) return false;
      if (isAdmin) return true;
      return Array.isArray(alert.stakeholderIds) && alert.stakeholderIds.includes(userId);
    });

    const hasActiveAlert = urgentAlerts.length > 0;

    const mostUrgentDeadline = urgentAlerts.reduce((earliest, alert) => {
      const d = alert.mostUrgentDeadline;
      if (!d) return earliest;
      if (!earliest) return d;
      return new Date(d) < new Date(earliest) ? d : earliest;
    }, null);

    return { urgentAlerts, hasActiveAlert, mostUrgentDeadline };
  }, [state?.activeRegulatoryAlerts, userId, isAdmin]);
}
